export class Vector {
  x: number;
  y: number;

  constructor(x = 0, y = 0) {
    this.x = x;
    this.y = y;
  }

  private operate(
    v: Vector | number,
    // arithmetic operation function
    fn: (a: number, b: number) => number,
  ): this {
    if (v instanceof Vector) {
      this.x = fn(this.x, v.x);
      this.y = fn(this.y, v.y);
    } else {
      this.x = fn(this.x, v);
      this.y = fn(this.y, v);
    }
    return this;
  }

  // mutable operations
  add(v: Vector | number): this {
    return this.operate(v, (a, b) => a + b);
  }

  subtract(v: Vector | number): this {
    return this.operate(v, (a, b) => a - b);
  }

  multiply(v: Vector | number): this {
    return this.operate(v, (a, b) => a * b);
  }

  divide(v: Vector | number): this {
    if (
      (v instanceof Vector && (v.x === 0 || v.y === 0)) ||
      (typeof v === 'number' && v === 0)
    ) {
      throw new Error('Division by zero');
    }
    return this.operate(v, (a, b) => a / b);
  }

  clone(): Vector {
    return new Vector(this.x, this.y);
  }

  static deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
  }

  static rad2deg(rad: number): number {
    return rad * (180 / Math.PI);
  }

  static fromAngle(deg = 0, radius = 1): Vector {
    return new Vector(
      radius * Math.cos(Vector.deg2rad(deg)),
      radius * Math.sin(Vector.deg2rad(deg)),
    );
  }

  static randomRange(from: number, to: number): number {
    return from + Math.random() * (to - from);
  }
}
